export const LOADING_OBJECTIVE_HISTORY = "LOADING_OBJECTIVE_HISTORY";
export const GET_OBJECTIVE_HISTORY = "GET_OBJECTIVE_HISTORY";
export const OBJECTIVE_HISTORY_FAIL = "OBJECTIVE_HISTORY_FAIL";
export const LOADING_OBJECTIVE_HISTORY_BY_ID = "LOADING_OBJECTIVE_HISTORY_BY_ID";
export const GET_OBJECTIVE_HISTORY_BY_ID = "GET_OBJECTIVE_HISTORY_BY_ID";

